export default __webpack_public_path__ + "static/media/BG-VELASCO_Desktop.a506350d.jpg";